export default __webpack_public_path__ + "static/media/laforge1.143956d6.png";